export default {
  "+wet4N": "Erreur du code de vérification",
  "2QzYmY": "Annuler",
  "32AbcK": "Sélectionner une entreprise",
  "4R5GEq": "Accueil",
  "9Kfib+": "Erreur inconnue",
  "9UZxwP": "Veuillez saisir le code de vérification",
  "9cYMNA": "Informations sur la société",
  "9ljNkr": "Renvoyer",
  "9vpYSL": "Supprimer la société",
  "EWMpn/": "Supprimer le rôle",
  FEb7U2: "Confirmer",
  "J3BW/8":
    "Veuillez saisir le code de vérification que vous avez reçu par e-mail",
  "QK/hAI": "Afficher les autorisations",
  TqDOFU: "Veuillez ne pas envoyer de codes de vérification fréquemment !",
  XeiAal: "Supprimer",
  aiBGBs: "Supprimer avec succès",
  azDNha: "Envoyé avec succès",
  "e/6XZC": "Vous n'avez pas reçu le code de vérification ?",
  jNxbTC: "Le code de vérification ne peut pas être vide",
  l1fZNE: "Impossible de décocher toutes les cases",
  "2MYr1m": "Connexion",
  "lzP/we": "Téléchargement",
  m0Qdyj: "Échec de la vérification",
  nJCPaY:
    "L'utilisateur n'a pas d'adresse e-mail liée et ne peut pas être vérifié",
  x79O39: "Etes-vous sûr de supprimer ?",
  xxETOY: "Configuration des autorisations des données de l'entreprise",
  yGWx2z: "Erreur de paramètre",
  Unvxiq: "Changer de compte",
  ggvI6Z: "Sélectionner tout",
  lKbhpS:
    "Période de mise à jour des niveaux de gris de l'appareil (heure locale)",
  ayUfs1: "L'heure de fin ne peut pas être antérieure à l'heure de début",
  "03eM6t": "200 éléments/page",
  "7/cUwn":
    "Période horaire pouvant être mise à jour sur l'appareil (heure locale)",
  SGDlQ6: "{total} éléments au total",
  "arp+TQ": "50 éléments/page",
  e8OyHO: "20 éléments/page",
  iyOrrD: "100 éléments/page",
  yXsHgv: "10 éléments/page",
  "+/R6RX": "Statut de la tâche",
  "+0SHNk": "Adresse MAC Wi-Fi",
  "+4lD9e": "Nom",
  "+74JfZ": "Exemple : Device_000001_Gaoqiao Store_Android",
  "+7V2pl": "commun",
  "+CLSks":
    "2. Le type de système de périphérique auquel cette règle de dénomination s'applique",
  "+GQdfc": "Jeton de mise à jour",
  "+L9lak": "Appliquer le modèle d'alarme",
  "+TzicH": "magasin",
  "+gbx50": "Condition d'alarme",
  "+kHAfa": "Veuillez remplir les détails du magasin",
  "+m8vFq": "Détails de la règle de dénomination",
  "/8GfsH": "Quatre",
  "/99v4N": "Tous les magasins",
  "/CxA3j": "Ajouter un sous-magasin",
  "/Qlgz9": "Télécharger un appareil Windows",
  "/SqqyP": "Entrez le numéro de série de l'appareil",
  "/cqdKk": "télécharger",
  "/sI6h+": "personnes",
  "0KH9Qi": "Type de système d'appareil",
  "0VK6Tv": "Statut de l'entreprise",
  "0YYUNG": "{num} balises sélectionnées",
  "0iTEVO": "Afficher le jeton",
  "0uRy1k": "un",
  "11uVJ/": "Recevoir l'objet",
  "19+woq": "Détails du magasin",
  "1M03Dq": "Modèle de planning",
  "1PtjRr": "Nom de l'appareil",
  "1SslIM": "Fermer l'application",
  "1X8SYs": "Latitude et longitude",
  "1sAivX": "Adresse MAC Ethernet",
  "1sj5Sj":
    "Supprimer tous les modèles de planification appliqués à cet appareil",
  "2/LdaO": "Stocker les informations de configuration",
  "2JW1Pt":
    "Veuillez choisir si vous souhaitez envoyer des e-mails en même temps",
  "2nV3tA": "Aucun magasin sélectionné",
  "2opnVU": "Pendant l'exécution",
  "2qrsN7": "Veuillez sélectionner l'adresse du magasin",
  "2r/XUW": "Supprimer tous les modèles de planning appliqués par cette balise",
  "3HzQUc": "Exporter JSON",
  "3QXG/d": "Version originale",
  "3XHWMy": "Jeudi",
  "3aYG4L":
    "Supprimez le modèle d'alarme actuellement appliqué à l'appareil et ne surveillez et n'envoyez plus d'alarmes.",
  "3h+3Xm": "Pas ouvert aux affaires",
  "3jyOjJ": "S'il faut modifier l'appareil sélectionné en \"Enregistré\"",
  "3qF993":
    "Vous ne pouvez pas transférer un appareil qui ne fait pas partie de votre entreprise actuelle.",
  "4/e9qs": "Veuillez remplir le nom",
  "4Xdib8": "La période ne peut pas être vide",
  "4c3uw8": "Quitter le magasin",
  "4vWL+W": "Importer un appareil",
  "4wi+/p": "modèle",
  "5+oaTO": "état de la dernière mise à jour de l'image",
  "5Cm9U3": "Notification des messages",
  "5Hy0Qx": "Ne peut pas être transféré dans le même magasin",
  "5KtG4i": "Rechercher une entreprise",
  "5WKL9+": "Sélectionnez le statut du magasin",
  "5jpkHg": "statut en ligne",
  "5p8cBO": "Gestion des comptes",
  "5ytYaf": "Ajouter un nouveau modèle de planning",
  "6+iYA0": "numéro de série",
  "60Ixlm": "Nom du modèle d'alarme",
  "6eB+xj": "Veuillez sélectionner un utilisateur spécifique",
  "6pDRb2": "Veuillez entrer un mot de passe valide",
  "7ip592": "1. Nom de la règle de dénomination",
  "88CuCZ":
    "3. Établir une méthode de dénomination pour les équipements enregistrés dans ce magasin (remplir automatiquement le nom de l'équipement)",
  "8PESa6": "Désactiver",
  "8huAxo": "Ajouter une nouvelle règle",
  "8u3CYe": "Nom de la règle de dénomination",
  "8usMqO": "Supprimer l'annonce",
  "8zN+hZ": "Exécuter l'application",
  "9/Vb7e": "Télécharger un appareil",
  "919TK9": "Formats pris en charge : xls, xlsx",
  "9AsSO/":
    "Veuillez choisir si vous souhaitez envoyer des messages texte en même temps",
  "9UefLp": "Étiquette",
  "9g6s9o": "Veuillez remplir le code du magasin",
  "9iKk2b": "Numéro de départ",
  "9r00YD": "Gestion des annonces",
  "9w+ho+": "compte",
  "9yRpjk": "Samedi",
  "A/eXwT": "Supprimer tous les modèles d'alarme appliqués à cette étiquette",
  A5kf1W: "Liste de toutes les entreprises",
  ANeFu6: "Vérifier le mot de passe",
  Abqe2U: "Adresse du magasin",
  Axagls: "Veuillez sélectionner l'heure de fin",
  AyWMlZ: "Ajouter une tâche planifiée",
  B57Wbu: "Aucun appareil sélectionné",
  BBpRbn: "Supprimer tous les modèles d'alarme appliqués à ce magasin",
  BC74I9: "Message rapide",
  BQcLxf: "descendre",
  BYbqwY: "Faites glisser votre fichier ici ou cliquez sur Télécharger",
  BwXapw: "Veuillez contrôler le nom de la catégorie dans les 500 caractères",
  C6cGK1: "Le nom du modèle de planification ne peut pas être vide",
  CLqPBU: "modifier",
  CPTAAj: "Augmentation des nombres naturels",
  D5HOUz: "Sélectionnez le statut",
  DADacD: "Supprimer tous les modèles de planning appliqués à ce magasin",
  DFyP1k: "Fermer la boutique",
  DxGUhN: "Sélectionnez tous les appareils",
  E1GPl7: "propriétaire",
  EGvInA: "Liste des alarmes de l'appareil",
  EM8lAi:
    "Période horaire actualisable par équipement de l'entreprise (heure locale)",
  "EO+Nlk":
    "Le fichier est en cours de téléchargement, veuillez ne pas fermer la boîte de dialogue.",
  EwM8Kj: "Etes-vous sûr de vouloir déménager ?",
  Ey9rBq: "Êtes-vous sûr de vouloir le supprimer ?",
  F2LJDJ: "Êtes-vous sûr de vouloir supprimer ?",
  F3ndvv: "Échec de la suppression",
  FBH89G: "version modifiée",
  FNIJXx: "Veuillez sélectionner la lecture par défilement",
  "FaJ/jI": "Aucun fichier sélectionné pour l'importation",
  FbCeo1: "valeur de déclenchement",
  FbsCUK: "téléphone portable",
  "Fr1I/b": "étiquette",
  Ft60hS: "Équipement Nubis",
  G4XFn6: "Modèle de matériel",
  G4qgGm: "tous les utilisateurs",
  G5gg2V: "Le titre de l'annonce est requis",
  G6i1QR: "Sélectionnez l'adresse",
  G9APSK: "Modifier les règles de dénomination",
  Gk0Mt5:
    "Êtes-vous sûr de vouloir réinitialiser ({name}) le dispositif d'alarme ? Les règles d'alarme continueront à être surveillées après la réinitialisation.",
  GnzEo7: "heure de la dernière mise à jour de l'image",
  GujK99:
    "Si le contenu du modèle d'alarme est mis à jour ultérieurement, il sera également synchronisé avec l'appareil appliqué.",
  Gwj7xc: "Restaurer les valeurs par défaut",
  H5s58g: "24 heures",
  HN1dNJ: "Tous les comptes",
  HOHQFs: "Le nom de la règle de dénomination ne peut pas être vide",
  HRXYJB: "Toutes les entreprises",
  "HdxQ2/":
    "Fichiers de configuration liés au magasin et règles de dénomination",
  "Hv/pfB": "Mardi",
  I37xbU: "Veuillez remplir",
  ITbo35: "Le nom du magasin ne peut pas être vide !",
  IqkgWZ: "Mots-clés",
  "Iwt/8W": "annotation",
  "J0D5h+": "heure de début",
  J9jPRL: "Copié avec succès",
  JJl2M9: "Exporter",
  JLMIof: "Télécharger un appareil Android",
  JRhVym: "Les heures d'ouverture ne peuvent pas être vides",
  JeJAmT: "Rebaptiser",
  Jh62y5: "Tous les appareils",
  Jp7u8z: "tour",
  KJHvMA: "Gestion du magasin",
  KlWMzW: "Activé",
  Km733q: "Veuillez sélectionner une heure de début",
  Kwqd8h: "Personne de contact",
  L24ioQ: "titre",
  L80hmc: "Le titre de l'annonce ne doit pas dépasser 30 caractères",
  LNGTru: "Liste des échecs de planification des appareils",
  LWSLHa: "Conseils aimables",
  Lfia0v: "Configurer le calendrier",
  "LuP+H0": "décrire",
  LwhdsE: "Basculer la sélection multiple",
  M404r0: "deux",
  MZ5Ei7: "La période chevauche la {num}ième période",
  MmsEyp: "registre",
  MnTdIi: "Nombre de déclencheurs",
  N52KMq: "Adresse détaillée",
  NGs9sO: "retour",
  "NM/lRq": "Annuler le téléchargement",
  NjB2tN: "Veuillez sélectionner le statut de votre entreprise !",
  OMcnk6: "Fabricant",
  OSqnZu: "S'il faut changer la version de l'appareil sélectionné en",
  "OZGX3+": "Liste des annonces",
  OaZpDP: "UUID",
  OcijhH: "Numéro de série de la carte mère",
  OsMncl: "Pas allumé",
  "P/eul9": "Non",
  PVmkgT: "Veuillez remplir le nom court",
  PaMvre: "Liste des règles d'alarme",
  PnYplH: "équipement",
  PrIueu: "Ouvert 24 heures",
  "Py/5UG": "Le nœud exploité n'existe plus, veuillez l'opérer à nouveau.",
  "Q+0CDu": "Ajouter des règles de dénomination",
  "Q2/NzC": "{num} appareils sélectionnés",
  QHc9Qg: "Contenu de l'annonce",
  QHhMxE: "Sélectionnez un rôle",
  QLYuf8: "Toutes les entreprises",
  QV3pnn: "État",
  QpOtgZ: "Nom du magasin",
  Qpcx6F: "Le contenu de l'annonce est requis",
  Qpi3DY: "jour",
  "QsAe0/": "Échec de l'enregistrement",
  QwHI8Q: "Résultats de la requête :",
  R2D5Dv: "temps de création",
  RCjVsb: "ID de l'appareil",
  RNaGVr: "Liste d'échec des tâches",
  RQyKsa: "Annonce de la plateforme",
  RWBRyt: "La carte de répartition des équipements est en construction",
  RndUeh: "Temps d'exécution estimé",
  RyXQqJ: "Temps de téléchargement",
  S1QSWC: "Importer dans le sous-magasin",
  S57QRB: "Filtrer par",
  SbZhau: "La tâche de démarrage doit spécifier un périphérique de démarrage",
  SkK50H: "Veuillez ajouter une tâche planifiée",
  SwMBFl: "Appliquer le modèle de planning",
  T3CtvK: "Le nom de la catégorie ne peut pas être vide",
  TDSTTj: "Sélectionnez un modèle de planning",
  TDuPUp: "Déclenché",
  TLZPhr: "Lundi",
  TYAJpp: "{num} magasins sélectionnés",
  UA7mv6: "Heure de dernière mise à jour à Ora",
  UBbWUL: "Aucun modèle sélectionné",
  UZ49sl: "Numéro de téléphone du responsable",
  UtE0dS: "fonctionner",
  "Uu/nFu": "Supprimer tous les modèles d'alarme appliqués à cet appareil",
  V0RiZp: "Opération réussie",
  Vd3wZV: "dans l'ensemble",
  Ve9Ksw: "Déplacer le magasin",
  ViVQNi: "Rôle",
  VqEr9u: "Nombre de magasins auxquels postuler",
  Vx4M25: "code de magasin",
  "W/wIZ8": "responsable",
  WYHxWn: "trois",
  WYtW9Y: "Veuillez sélectionner une version",
  WdyIyo: "Temps de fonctionnement",
  WtPk7v: "Envoyer des SMS simultanément",
  WxPZOH: "Exécuter {num} fois",
  WypzMq: "Tâches planifiées",
  Wzv7kF: "Veuillez sélectionner un magasin",
  X2PYza: "Détails de l'appareil",
  "XKj/en": "Numéro de série du BIOS",
  "XLdI1+": "Puissance du Wi-Fi",
  XMBOec: "Supprimer la balise",
  XPFi6q: "bande",
  XmRKnc: "Remarque",
  YYGRyG: "Veuillez télécharger les pièces jointes",
  YeF1dY: "fuseau horaire",
  YpXN8m: "Heure du dernier déclenchement",
  YwEzx2: "Vérifiez les champs qui doivent être affichés",
  ZGYHyC: "L'heure de début ne peut pas être vide",
  ZQ91U9: "Maison",
  ZUPzqr: "allumer",
  ZdO12B: "Postuler pour magasiner",
  "Zvt+2g": "entreposage",
  aBleoN: "Sélectionnez un modèle d'alarme",
  aGxRt2: "contenu",
  "aN+DgN": "temps d'activation",
  akvGrq: "Configurer les règles",
  askOz5: "Rechercher une adresse",
  "b+Dz+s": "Liste de tous les magasins",
  b5l2vN: "sauvegarder",
  bBz42a: "statut de mise à jour",
  "bE+h3K": "État de l'appareil",
  bFBjSK: "cinq",
  bOKDVF: "Basculer la radio",
  biXcnk: "Email du responsable",
  bqbDVw: "Requête",
  bzfrYI: "Configuration des annonces",
  cDZ00w: "Vérifier",
  "cZ9/ZC": "Supprimer [{name}] ?",
  cawvIS: "Dernière mise à jour",
  cgIBtg: "Sélectionnez le niveau supérieur",
  cr1ymH: "Veuillez sélectionner l'heure d'envoi",
  "d7i/AT": "couche supérieure",
  dEXfrL: "Intervalle d’état de santé de l’appareil",
  dGBGbt: "tous",
  drCsUI: "entreprise",
  eAgY2G: "Développer les filiales",
  eCCa0L: "Type de tâche",
  "eP/37G": "Heure d'inscription",
  eeCxuz: "Type de système d'exploitation",
  evJP5c: "Règles de dénomination",
  f7Dpbl:
    "Téléchargez le modèle et améliorez le contenu selon les invites du modèle",
  "fc12+X": "Vendredi",
  fz2pkM: "Le nœud a été supprimé",
  gU4eZD: "Gestion des alarmes",
  gmUXEi: "Valeur caractéristique de l'équipement",
  gnNjS5: "Nom de l'appareil personnel",
  gpg5DN: "Voir l'annonce",
  gplM71: "tous les jours",
  "gyh+d1": "réseau filaire",
  "h/j3a5": "Numéro de téléphone du contact",
  h7w4pz: "Aucune donnée pour l'instant",
  "hD7/Lu": "montrer",
  "hDx3/S": "Mail",
  hEI4G8: "Nouvelle annonce",
  hYN7oM: "cacher",
  hkJXyi: "Configurer les tâches planifiées",
  i5MLJc: "Dernière mise à jour : {lastUpdate}",
  "i6kDf/":
    "Si l'appareil sélectionné contient {num} versions Nubis Free, les commandes de l'appareil ne seront pas disponibles.",
  iKomBu: "Pas encore de classement",
  iN7Lps: "mode cycle",
  ich0wH: "AppareilSN",
  ifGp4v: "2FA",
  "j/YGZ0": "carte",
  j3QWSE:
    "Le nombre de départ pour l'incrément d'un nombre naturel ne peut être qu'un entier positif",
  j6m8Si: "E-mail de contact",
  jAAXdQ: "Magasin d'équipement",
  jT6zKT: "Nombre d'appareils",
  "jhfb/7": "Enregistré avec succès",
  js3tZs: "Nom du modèle de planification",
  k7dy8j: "Fichiers de configuration associés",
  k9dozc: "Temps d'exécution",
  kG2Etz: "en ligne",
  khyRcw: "Veuillez sélectionner un fichier Excel",
  "kr+7Iy": "Rechercher un magasin",
  l36W55: "faire défiler la lecture",
  lK6HPZ: "Veuillez sélectionner un statut de magasin",
  lVgYx7: "Suspendu",
  lllhRf: "L'heure de fin ne peut pas être vide",
  loTFGc: "Anonyme",
  m1h20o:
    "Si le contenu du modèle de planification est mis à jour ultérieurement, il sera également synchronisé avec l'appareil appliqué.",
  mFIXSq: "Numéro de série de l'appareil",
  mKKd1R: "Veuillez sélectionner les destinataires",
  "mYa6W/": "Texte personnalisé",
  ma6S6y: "Affichage personnalisé",
  mn0ceu:
    "Il existe des règles de configuration en double, veuillez les ajuster.",
  "mpeFt+": "Règles d'alarme",
  nGubXb: "Détails du modèle de planification",
  nUSeQB: "Aucun compte sélectionné",
  nzsNwZ: "État de santé de l'appareil",
  "o+O5d1": "Veuillez sélectionner une mission",
  o5OLcm: "Abréviation du magasin",
  o8tJYm: "commande de périphérique",
  o9lryN: "Dimanche",
  "oFt+cN": "Test de vitesse du réseau",
  oW4Uka: "attribuer",
  obfTaf: "Configuration du magasin",
  ojz0Ke: "Voir plus >",
  oru5FY: "Modifier le modèle de planning",
  "p/3Nn5": "réseau mobile",
  pBPyFt: "Version Nubis",
  pK94Zd: "Importer dans le magasin",
  "pV2t/S": "Informations de base",
  pXEyon: "Type d'appareil",
  peNVzr: "toutes les {num} semaines",
  peUIwk: "Créer une annonce",
  pfGGi0:
    "Supprimez le modèle de planification actuellement appliqué à l'appareil et ne l'exécutez plus.",
  pielKO: "Périphérique de démarrage",
  q6qKtH: "Conditions de requête :",
  q9PHLT: "Aucune annonce pour l'instant",
  q9YGIf: "Entreprise",
  qDba8m: "État de l'appareil hors ligne",
  qUKj7E: "copie",
  qUiH5y: "Les règles de configuration ne peuvent pas être vides",
  "qqwM/t": "Fichier de configuration",
  qyh9hz: "Heures d'ouverture",
  "r0/TUu": "Bien sûr",
  "r2dEd/": "réinitialiser",
  rAKRwm: "Sélectionnez la version de l'appareil",
  rDRAr0: "Version du système d'exploitation",
  s1l1Jq: "Gestion de magasin et de compte",
  s7NSze:
    "Veuillez saisir le mot de passe de votre compte avant de confirmer l'opération.",
  s9U9qn: "Définir l'alarme",
  sGYTej: "repos",
  sOIerB: "Non activé",
  sVsXUO: "Mercredi",
  sZSyGZ: "activer",
  srEpKw: "Téléchargement",
  srpWCM:
    "Cochez les champs qui doivent être affichés et faites-les glisser pour les trier.",
  t5gffJ: "Informations sur l'équipement",
  tugHWJ: "Retour à la liste des annonces",
  u3dVQz: "hebdomadaire",
  ubuOXs: "Inscrit",
  ujBeLh: "Notification publique du système de maintenance",
  "uoZwj+": "Créateur",
  uuRzdk: "Appartenir au magasin",
  v04auv: "heure de fin",
  vD5wnY:
    "Cochez le magasin auquel vous souhaitez appartenir, ce qui signifie que vous avez l'autorisation du magasin",
  vDCwZ9: "Télécharger des fichiers",
  vr5TVT: "Veuillez entrer",
  wOHHSJ: "monter",
  wQAiLI: "Réinitialiser le rappel",
  wYygRu: "expéditeur",
  "wrU/Kc": "tous les {num} jours",
  x34QXR: "L'heure de fin ne peut pas être antérieure à l'heure de début",
  xI0mPJ: "Déjà allumé",
  xISm1t: "activation",
  xUjLTE: "recherche",
  xXdMar: "Spécifier l'utilisateur",
  xuf2rG: "Tous les magasins",
  xx40g7: "Titre de l'annonce",
  "y+WxsP": "Avis éditorial",
  yKFvYY: "Envoyer des e-mails simultanément",
  yOMNOj: "Oui",
  yReEcE: "Sélectionnez l'étiquette",
  yb3AuG: "Hors ligne",
  ybGQQ3: "Aucun résultat pertinent",
  yc6ZUL: "Dernier statut mis à jour",
  ydktLD: "délimiteur",
  yeCGlM: "six",
  yfhtRM: "appendice",
  ygAHaf: "Heure d'envoi",
  yy7EDI: "télécharger",
  zftpop: "Sélectionner un utilisateur",
  znuEgQ: "Ajouter des heures d'ouverture",
  zok1hp: "Emplacement C",
  zvaxmN: "Gestion des plannings",
  zyMKgy: "Sélectionner un magasin",
  o5QBKU: "Entreprise modifiée",
  "1yM7WW": "Supprimer le périphérique sélectionné ?",
  DqB8kg: "Supprimer le périphérique",
  QH21BX: "Enregistrement par lots des appareils",
  TlDh4N: "Supprimer les appareils par lots",
  UcumBq: "Notification d'alarme",
  X9zJwr: "Attribuer les appareils par lots",
  lkP6UV: "Mettre à jour le périphérique",
  wLyMu9: "Améliorez le contenu selon les invites du modèle",
  FQM81K: "Modifier le statut du magasin sélectionné à",
  WqfGVu: "Limité à 30 mots",
  hV5chR:
    "Veuillez sélectionner si vous souhaitez afficher une fenêtre contextuelle",
  vD7UHb: "Fenêtre contextuelle",
  "0Drg5o": "J'accepte les conditions ci-dessus",
  "7pY6K/": "Conditions générales",
  CNkomH: "Conditions éditoriales",
  CoaQps: "Gestion des termes",
  "HHA/d7": "Liste des termes",
  UH1kCc: "Ajouter",
  "VzqtN+": "Les conditions générales sont obligatoires",
  hOtsIx: "Nouvel article",
  ilUpPP: "Renvoyer la liste des termes",
  "j+y4w+": "Le titre des conditions est obligatoire",
  j4CmNU: "Voir les conditions",
  jJg298: "Titre de l'article",
  t4lrWD: "Le titre de l'article ne doit pas dépasser 30 caractères",
  z7A1Fc: "Créer des conditions",
  "OY+bYK": "Confirmer, ne plus afficher",
  "+d1f6p": "Télécharger le périphérique Linux",
  UrM0bR: "Informations d'authentification",
  "+uAolt": "Exemple : Permettre aux utilisateurs de personnaliser facilement les titres, les icônes et le texte des sites Web pour une expérience Web personnalisée.",
  "0UAhKu": "Exemple : https://nubiscloud.freshdesk.com/support/home",
  "0h3ZUE": "Téléchargement depuis le Centre de compte",
  "0lEh3g": "Téléchargement depuis l'espace Nubis",
  "0xMj0V": "Exemple : Fournir une nouvelle version ou mettre à jour l'image de l'appareil",
  "3DMdxJ": "Modifier l'onglet Centre de compte",
  "4ImW13": "Exemple : Gestion de la boutique",
  "52LsQF": "Exemple : Centre de compte",
  "5BTra1": "Exemple : Plateforme",
  "61gplm": "Téléchargement de texte",
  "6sZvzw": "Remplacer les mots-clés du Centre de compte",
  "7bKyxU": "Les images téléchargées seront stockées dans l'explorateur de fichiers Nubis Drive. La corruption ou la suppression d'un fichier entraînera l'échec du chargement des images",
  "7q8OJE": "Modifier la plateforme",
  "8TfVSD": "Modifier l'onglet Plateforme",
  "8pToBN": "Exemple : Nubis",
  "9/8z30": "Permettre aux utilisateurs de personnaliser facilement le titre, l’icône et le texte du site web pour une expérience web personnalisée",
  "9C+wuW": "Exemple : Gestion des appareils",
  "D1cAYC": "Exemple : Centre des appareils",
  "FKBH20": "Exemple : Espace Nubis",
  "G+eQYn": "Exemple : Gestion de la boutique et des comptes",
  "G2LkOf": "Téléchargement de la gestion des annonces",
  "I9uxGU": "Exemple : Service global, Laissez libre cours à votre imagination, Offrez une expérience intelligente",
  "K1Xqdl": "Exemple : Gestion des autorisations",
  "LTVlAP": "Téléchargement vers le Centre de mise à niveau",
  "Q1/SUP": "Exemple : Avis public du système de maintenance",
  "QAN35o": "Exemple : Gestion des appareils, surveillance, contrôle à distance, etc.",
  "R8nCNR": "Téléchargement vers la gestion des appareils",
  "TVuUjT": "Ora",
  "U08bUN": "Télécharger vers le Centre des appareils",
  "Wu2nnZ": "Présentation de la plateforme",
  "ZP1/uy": "Exemple : Gestion des autorisations des rôles de la plateforme Nubis",
  "ayjmy+": "Exemple : Gestion de vos appareils et groupes dans le monde entier",
  "bhXvJB": "Téléchargement de la gestion des autorisations",
  "cAIDk5": "Centre d'assistance",
  "d3b8dv": "Téléchargement de la gestion personnalisée",
  "dFHONh": "Nubis",
  "dWy8l5": "Exemple : Ora",
  "fZJ9SZ": "Exemple : Gestion des comptes de vos partenaires et clients",
  "jAmQmn": "Exemple : Centre de développement",
  "kwx95y": "Exemple : Gestion personnalisée",
  "ov96O9": "Gestion personnalisée",
  "rM4ciX": "Exemple : Gestion des annonces",
  "uDYj3x": "Centre du site web",
  "uRrPru": "Téléchargement de la gestion de la boutique",
  "vdUVb9": "Exemple : Centre de mise à niveau",
  "xrKftB": "Téléchargement d'icônes",
  "2IaM+V": "Centre de mise à jour",
  "EoXhnk": "Centre d'appareils",
  "JeSd9K": "Autre",
  "wzIKok": "Hérit des paramètres personnalisés de l'entreprise de niveau supérieur",
  "BQDKvZ" : "Exemple : Agent",
  "EO9pTF" : "Exemple : Cloud",
  "/NrLZv": "Quantité de licences",
  "1Dklb3": "Date d'effet automatique",
  "1dyq46": "CMS",
  "1t0NXU": "Date de paiement",
  "2DbIoa": "Détails de la commande",
  "2hUF5M": "Veuillez sélectionner au moins 1 licence",
  "2qqw4C": "Vendeur",
  "3Y6eOz": "Expiré",
  "5FboZ/": "Type",
  "6bBRd8": "Adresse e-mail du client",
  "6jMfox": "Enregistrements de commande reçus",
  "D0cpCO": "Quantité de licences",
  "EBMdAL": "Créé avec succès",
  "FDRhoz": "Envoyé",
  "G0UYbD": "Sélectionnez les licences",
  "GCrD1e": "Jours restants",
  "JeSd9K": "Autre", "JmnNA0": "Champ facultatif",
  "LG70v2": "Envoyer l'enregistrement de commande",
  "NZQWZL": "Formel",
  "PjtWQX": "{num} licences sélectionnées",
  "Plhuph": "Rechercher le numéro de commande, le numéro ERP",
  "Rrwy85": "Créateur",
  "TX6jKq": "Destinataire",
  "U+pKlD": "Supprimer le numéro de commande : {name} ?",
  "Xvn+2E": "Contact client",
  "YII2+w": "Date d'expiration",
  "YJbxtM": "Société destinataire",
  "ZIJmYm": "Gestion des commandes",
  "ZTs8/J": "Créer des licences",
  "a7AYs5": "Période de validité (jours)",
  "eM8o1Y": "Numéro de commande",
  "eUSpdN": "Afficher plus",
  "er7lkB": "Montant", "fyjje7": "Licence Clé",
  "gqvOsW": "Personne à contacter chez le client", "iTiIWl": "Aucune donnée correspondante trouvée",
  "k1xuGk": "Numéro de commande de recherche",
  "kPb1Wj": "N° ERP.",
  "lfUbAE": "Actif",
  "mPsm6o": "Test",
  "ouraCD": "Gestion des périphériques",
  "pUL1dA": "Supprimer la commande",
  "pecEGk": "Annuler",
  "sTreBL": "Date d'effet réelle",
  "sbThvA": "Société expéditrice",
  "svGx//": "Veuillez saisir un numéro valide",
  "tMGiGt": "Type de licence",
  "tsV2n0": "Créer une commande",
  "twizE+": "Adresse e-mail du commercial",
  "u6rHwS": "Date de génération de la commande",
  "vePxOp": "Normal", "wNYTXq": "Non utilisé",
  "wawZXM": "État de la licence",
  "xVTk70": "Chargement",
  "xxFsds": "Champs obligatoires",
  "0axARa" : "Date d'expiration",
  "0tqhdw" : "Les responsables et les cadres supérieurs recevront des e-mails de [{x}] entreprises, soit un total de [{y}] entreprises.",
  "4DfIa5" : "Le type de licence sélectionné ne doit pas être une version bêta.",
"4kc3eS" : "Le premier jour de chaque mois, le système enverra un e-mail concernant l'état des licences ou des appareils nécessitant une notification. Cet e-mail contiendra les informations suivantes.",
"7FTqlN" : "Aucune licence correspondante.",
"AfMAI0" : "L'appareil disposant d'une licence recevra automatiquement une nouvelle licence à l'expiration de la licence actuelle.",
"FQjcoc" : "Règles d'automatisation des licences.",
"GDWKlf" : "Numéro de série de l'appareil associé.",
"Iqlkbs" : "Licence non utilisée.",
"K5iYC8" : "Licences non utilisées dont la date d'activation automatique sera atteinte dans les 100 prochains jours.",
"NBz0wZ" : "Licences actuellement actives mais non attribuées à un appareil.",
"URkpah" : "Licences expirées.",
 "UjxKxu" : "Résiliées.",
"VaAWfW" : "Les licences dont la date d'expiration automatique est la plus proche sont prioritaires.",
"Wp2PXY" : "Paramètres de notification.",
"X2YceA" : "Licences inutilisées.",
"ZLqStU" : "Les appareils pré-importés recevront automatiquement des licences lors de leur enregistrement.",
"daUauj" : "Clé de licence, numéro de commande, numéro de série de l'appareil associé.",
"eFFkgE" : "Aperçu de l'inventaire des licences.",
"eHMGvf" : "Veuillez sélectionner une licence.",
"eR85km" : "Appareil disposant d'une licence autorisée expirant dans les 100 prochains jours. Si la licence expire et qu'aucune licence de remplacement n'est fournie, l'appareil sera mis en réserve.",
"fTfy0b" : "Le système appliquera automatiquement les licences conformément aux règles d'automatisation des licences.",
"ftSBnR" : "Licence associée.",
"lLC16+" : "Gestion des licences.",
"lQGDqR" : "Appareil déjà réservé ou suspendu.",
"lTtEaU" : "Réservé.",
"t0EXqz" : "Licences en vigueur.",
"vPHZLC" : "Filiales incluses.",
"xy6tQS" : "L'appareil enregistré via code OR ou API sera automatiquement licencié.",
"zE041n" : "Date d'expiration.",
"FQQECq" : "Obligatoire",
"ekxzlF" : "Nom"
};
